var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app-content" } },
    [
      _c(
        "vue-scroll",
        { ref: "body_scroll", attrs: { ops: _vm.ops } },
        [_c("app-content")],
        1
      ),
      _vm._v(" "),
      _vm.$store.getters.loginModal ? _c("login-reg") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.newMessage.show
        ? _c("alert-message", {
            attrs: {
              type: _vm.$store.getters.newMessage.type,
              messageTitle: _vm.$store.getters.newMessage.messageTitle,
              message: _vm.$store.getters.newMessage.message
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.forgetPassword ? _c("forget-password") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.newPassword ? _c("new-password") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.paymentModal ? _c("payment") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.isOpenTariffModel ? _c("templates") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.isOpenConfirmModal ? _c("confirm-modal") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.cvDownload.show
        ? _c("cv-download", { attrs: { cv: _vm.$store.getters.cvDownload.cv } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.openShareModal.show
        ? _c("open-share-modal", {
            attrs: { type: _vm.$store.getters.openShareModal.type }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.modalBuy ? _c("modalBuy") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.modalBuyLoad ? _c("modalBuyLoad") : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.modalLoader ? _c("modalLoader") : _vm._e(),
      _vm._v(" "),
      _c("v-tour", { attrs: { name: "myTour", steps: _vm.steps } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-332fccf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-332fccf4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/App.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-332fccf4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/App.vue
// module chunks = 0